import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import errorLog from './modules/errorLog'
import permission from './modules/permission'
import settings from './modules/settings'
import tagsView from './modules/tagsView'
import user from './modules/user'
import settingsMonitor from './modules/settingsMonitor'
import notifications from './modules/notifications'
import tangoEnv from './modules/tangoEnv'
import resultMessage from './modules/resultMessage'
import iRiskMonitor from './modules/iRiskMonitor'
import soundLibrary from './modules/soundLibrary'
import getters from './getters'


Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    app,
    errorLog,
    permission,
    settings,
    tagsView,
    tangoEnv,
    notifications,
    settingsMonitor,
    user,
    resultMessage,
    iRiskMonitor,
    soundLibrary
  },
  getters,
  mutations: {
    RESET_STORE: () => {
      store.commit('app/RESET_STORE')
      store.commit('permission/RESET_STORE')
      store.commit('settings/RESET_STORE')
      store.commit('settingsMonitor/RESET_STORE')
      store.commit('tagsView/RESET_STORE')
      store.commit('tangoEnv/RESET_STORE')
      store.commit('notifications/RESET_STORE')
      store.commit('iRiskMonitor/RESET_STORE')
      store.commit('soundLibrary/RESET_STORE')
    }
  }
})

export default store
